import { Avatar, styled } from '@mui/material';
import React from 'react';
import { Image as ImageIcon } from '@mui/icons-material';

const StyledAvatar = styled(Avatar)(({ theme, size, maxWidth }) => ({
	height: size,
	width: size,
	maxWidth: maxWidth,
	'& .MuiSvgIcon-root': {
		height: size / 3,
		width: size / 3
	}
}));

const ResponsiveImage = ({ src, size, maxWidth, ...rest }) => {
	return (
		<StyledAvatar
			src={src}
			variant="rounded"
			size={size}
			maxWidth={maxWidth}
			{...rest}
		>
			<ImageIcon />
		</StyledAvatar>
	);
};

export default ResponsiveImage;
